import React from 'react';

export const DefaultLayout = React.lazy(() => import('./DefaultLayout'));
export const GlobalLayout = React.lazy(() => import('./GlobalLayout'));
/*
export const TicketingLayout = React.lazy(() => import('./TicketingLayout'));
export const RecruitingLayout = React.lazy(() => import('./RecruitingLayout'));
export const LegacyLayout = React.lazy(() => import('./V1Layout'));
*/